export default "__VITE_ASSET__Cl2nrjGD__"